var map = {
	"./AI硬件集成.png": 47552,
	"./AI算法.png": 23208,
	"./logo.png": 90175,
	"./公司介绍.png": 36322,
	"./智能体平台.png": 88699,
	"./智能手表.png": 1368,
	"./智能玩具.png": 60789,
	"./智能眼镜.png": 17469,
	"./智能耳机.png": 63106,
	"./智能键盘.png": 25823,
	"./智能音箱.png": 74241,
	"./用AI让每一个硬件拥有智能.png": 45151
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 50393;